import { gql } from 'graphql-tag'
import { fragmentModuleNavigationLink } from '../../../../core/data-layer/modules/fragments'
import fragmentModuleReportsListItem from '../../modules/module-reports-list-item/fragment-module-reports-list-item'

export default gql`
  ${fragmentModuleReportsListItem}
  ${fragmentModuleNavigationLink}
  fragment BlockReportsListFragment on BlockReportsList {
    sys {
      id
    }
    contentType: __typename
    title
    itemsCollection {
      items {
        ...ModuleReportsListItemFragment
      }
    }
    previousReportsLink {
      ...ModuleNavigationLinkFragment
    }
  }
`
